"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePayStatusOwnerRelationIndex = void 0;
const validate_pay_status_owner_relation_index_function_1 = require("./validate-pay-status-owner-relation-index.function");
const generatePayStatusOwnerRelationIndex = (ownerId, ownerType, period) => {
    const ownerRelationIndex = `{${ownerId}}-{${ownerType}}-{${period}}`;
    const { ownerId: validatedOwnerId, ownerType: validatedOwnerType, period: validatedPeriod, } = (0, validate_pay_status_owner_relation_index_function_1.validatePayStatusOwnerRelationIndex)(ownerRelationIndex);
    if (validatedOwnerId !== ownerId ||
        validatedOwnerType !== ownerType ||
        validatedPeriod !== period) {
        throw new Error('Invalid owner relation index');
    }
    return ownerRelationIndex;
};
exports.generatePayStatusOwnerRelationIndex = generatePayStatusOwnerRelationIndex;
